module.exports = __webpack_public_path__ + "img/Palette-Puroak-ES.asset.9cba4282.svg";